import { render, staticRenderFns } from "./MiraFacts.vue?vue&type=template&id=719c736c&scoped=true&"
import script from "./MiraFacts.vue?vue&type=script&lang=ts&"
export * from "./MiraFacts.vue?vue&type=script&lang=ts&"
import style0 from "./MiraFacts.vue?vue&type=style&index=0&id=719c736c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719c736c",
  null
  
)

export default component.exports